import { Alert, Typography } from '@fe-toolkit/web-components/ssr'

export type TErrorAlertProps = {
  errorMessage: string
}

const ErrorAlert = ({ errorMessage }: TErrorAlertProps) => {
  return (
    <Alert isMinor variant="error">
      <Typography as="p" variant="speakUp">
        {errorMessage}
      </Typography>
    </Alert>
  )
}

export default ErrorAlert
